import React, { FC } from 'react';

interface PaymentMethodIconProps {
  variant: 'google' | 'apple' | 'card';
  className?: string;
  size?: {
    width?: number;
    height?: number;
  };
}

/**
 * @see public/img/svg/paymethod-*.svg
 */
const paymentMethodIcons: Record<PaymentMethodIconProps['variant'], string> = {
  google: 'paymethod-googlePay',
  apple: 'paymethod-applePay',
  card: 'paymethod-card',
};

export const PaymentMethodIcon: FC<PaymentMethodIconProps> = ({ className, variant, size }) => {
  const icon = paymentMethodIcons[variant];
  return <img className={className} src={`/img/svg/${icon}.svg`} alt={icon} style={{ width: 70, height: 33, ...size }} />;
};
